import './TraceIdInput.styles.scss';

import { Search } from '@signozhq/icons';
import { Input } from 'antd';
import ROUTES from 'constants/routes';
import { KeyboardEvent, useState } from 'react';
import { useHistory } from 'react-router-dom';

function TraceIdInput(): JSX.Element {
	const [traceId, setTraceId] = useState('');
	const history = useHistory();

	const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
		if (e.key === 'Enter' && traceId.trim()) {
			history.push(ROUTES.TRACE_DETAIL.replace(':id', traceId.trim()));
			setTraceId('');
		}
	};

	return (
		<Input
			className="trace-id-input"
			placeholder="Go to Trace ID"
			prefix={<Search size={14} />}
			value={traceId}
			onChange={(e): void => setTraceId(e.target.value)}
			onKeyDown={handleKeyDown}
			allowClear
		/>
	);
}

export default TraceIdInput;
